<template>
  <v-card class="widget-card" elevation="2">
    <v-card-title class="d-flex align-center pb-2">
      <v-icon color="success" class="mr-2">mdi-trending-up</v-icon>
      <span class="text-subtitle-1 font-weight-bold">Тренд продаж</span>
      <v-spacer />
      <v-chip x-small color="warning" outlined>В разработке</v-chip>
    </v-card-title>
    <v-card-text>
      <div
        class="d-flex flex-column align-center justify-center py-6 grey--text"
      >
        <v-icon size="48" color="grey lighten-2">mdi-chart-line</v-icon>
        <div class="text-caption mt-2">
          Данные по продажам появятся в следующей версии
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SalesTrendWidget",
};
</script>

<style scoped>
.widget-card {
  border-radius: 12px;
}
</style>
